import { usePlatform } from "./hooks/usePlatform.js";
import { DesktopApp } from "./DesktopApp.js";
import { MobileApp } from "./MobileApp.js";

export function App() {
  const { isMobile } = usePlatform();
  return isMobile ? <MobileApp /> : <DesktopApp />;
}
